module["exports"] = [
  "?#? #?#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_CA/address/postcode.js
// module id = 438
// module chunks = 0